import * as React from 'react';
import AccordionCore from './accordion-core';
export const AccordionContext = React.createContext({
    openItems: [],
    setOpenItems: /* istanbul ignore next */ () => null,
});
const Accordion = (props) => {
    return (React.createElement(AccordionCore, Object.assign({}, props)));
};
export default Accordion;
